import type { IconSvgObject } from './types';

const PayoneerIcon: IconSvgObject = [
  ["circle", { cx: "11.9999", cy: "12", r: "9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default PayoneerIcon;
